module.exports = __webpack_public_path__ + "static/project-header-82735915a6a29c4655eb1b3a4ef27422.jpg";